<div [style.height.px]="dimensions?.componentHeight"
     [style.cursor]="!!select.observers.length ? 'pointer' : null"
     (click)="onHostClick($event)"
     class="content-preview">
    <div class="navbar-preview">
        <ng-container *ngFor="let navbarMenuClass of navbarMenuClasses">
            <div [ngClass]="navbarMenuClass"
                 [style.height.px]="dimensions?.bulletDiameter"
                 [style.width.px]="dimensions?.bulletDiameter"
                 class="navbar-menu-preview">
            </div>
        </ng-container>
    </div>
    <div class="sidenav-wrapper-preview">
        <div class="sidenav-menu-preview">
            <div *ngFor="let item of sidebarMenuItems"
                 [style.height.px]="dimensions?.itemHeight"
                 [style.border-radius.px]="dimensions?.itemBorderRadius"
                 class="sidenav-menu-item-preview">
            </div>
        </div>
        <div class="sidenav-content-preview">
            <div class="card-preview">
                <div *ngFor="let cardElementClass of cardElementClasses"
                     class="card-item-wrapper-preview">
                    <div [ngClass]="cardElementClass"
                         [style.height.px]="dimensions?.bulletDiameter"
                         [style.width.px]="dimensions?.bulletDiameter"
                         class="card-item-bullet-preview">
                    </div>
                    <div [style.height.px]="dimensions?.itemHeight"
                         [style.border-radius.px]="dimensions?.itemBorderRadius"
                         class="card-item-preview">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
